import { useState } from "react";

import type { NewStoreFormValuesType } from "@hz/stealthy-gmc-cloaker-common/api-types/store";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { Box , useToast } from "@chakra-ui/react";

import { StoreDetailsForm } from "@components/StoreDetailsForm";

import { useAddStoreMutation } from "@state/apiSlice/requests";
import type { AppDispatch } from "@state/store";
import { selectUserState } from "@state/userSlice/userSlice";

export const NewStoreFlow = () => {
  const [addStore] = useAddStoreMutation();
  const toast = useToast();
  const { billing } = useSelector(selectUserState);
  const navigate = useNavigate();

  const goBackHandler = () => {
    navigate("/");
  };

  const submitHandler = async (storeDetails: Partial<NewStoreFormValuesType>) => {
    const { domain, platform, countries } = storeDetails;

    if (!domain || !platform || !countries?.length) {
      toast({
        title: "Missing required fields",
        position: "bottom-right",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const payload = [
      {
        id: `store-${Date.now()}-${uuidv4()}`,
        domain,
        platform,
        countries,
      },
    ];

    try {
      await addStore(payload).unwrap();

      navigate("/");

      toast({
        title: "Store added successfully",
        position: "bottom-right",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (err) {
      console.error(err);
      toast({
        title: "Failed to add store. Please try again.",
        position: "bottom-right",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };
  return (
    <Box
      maxW="2xl"
      mx="auto"
    >
      <StoreDetailsForm
        hideCancelButton={false}
        onCancel={goBackHandler}
        selectedPlan={billing?.plan || ""}
        onBack={goBackHandler}
        onSubmit={submitHandler}
        showSteps={false}
        showBackToPlan={false}
        buttonSubmitText="Add Store"
      />
    </Box>
  );
};
